import {
  Button as MuiButton,
  ButtonProps as MuiButtonProps,
  SxProps,
  Theme,
  useTheme,
} from '@mui/material'
import React from 'react'

import rem from '~/utils/ui'

export type ButtonVariant = 'big' | 'medium' | 'small'
export type ButtonColor = 'primary' | 'secondary'

export interface ButtonProps extends Omit<MuiButtonProps, 'size' | 'variant'> {
  size?: ButtonVariant
  color?: ButtonColor
  startIcon?: React.ReactNode | null
  endIcon?: React.ReactNode | null
  fullWidth?: boolean
  customSx?: SxProps<Theme>
}

export default function AltGrowthButton({
  size = 'medium',
  color = 'primary',
  children,
  startIcon = null,
  endIcon = null,
  fullWidth = false,
  customSx = {},
  ...props
}: ButtonProps) {
  const theme = useTheme()

  const styles = {
    base: {
      textTransform: 'none',
      borderRadius: 2,
      border: `${rem(1)} solid`,
      borderColor: theme.palette.secondary2,
      '&:hover': {
        borderColor: theme.palette.tertiary5,
        backgroundColor: theme.palette.tertiary3,
        color: theme.palette.secondary2,
      },
    },
    colors: {
      primary: {
        bgcolor: theme.palette.secondary2,
        color: theme.palette.common.white,
      },
      secondary: {
        bgcolor: theme.palette.common.white,
        color: theme.palette.secondary2,
      },
    },
    big: {
      height: rem(50),
      fontSize: rem(16),
      padding: rem(16),
    },
    medium: {
      height: rem(32),
      fontSize: rem(14),
      padding: `0 ${rem(16)}`,
    },
    small: {
      height: rem(28),
      fontSize: rem(12),
      padding: `0 ${rem(12)}`,
    },
  } as const
  return (
    <MuiButton
      {...props}
      startIcon={startIcon}
      endIcon={endIcon}
      fullWidth={fullWidth}
      sx={{
        ...styles.base,
        ...styles.colors[color],
        ...styles[size],
        ...customSx,
      }}
    >
      {children}
    </MuiButton>
  )
}
